<div *ngIf="isVisible" class="modal-overlay" (click)="close()">
  <div class="modal-dialog modal-large" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <div>
        <h2 class="modal-title">Request Details - {{ requestData?.id }}</h2>
        <div class="flex items-center gap-3 mt-2 text-sm text-gray-400">
          <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium"
                [ngClass]="'status-badge-' + (requestData?.status || '').toLowerCase().replace('-', '')">
            {{ requestData?.status }}
          </span>
          <span>{{ requestData?.projectName }}</span>
        </div>
      </div>
      <button class="modal-close" (click)="close()">×</button>
    </div>
    
    <!-- Modal Tabs -->
    <div class="flex border-b border-slate-700 px-6">
      <button *ngFor="let tab of tabs" 
              (click)="setActiveTab(tab.id)"
              class="px-4 py-3 text-sm font-semibold border-b-2 transition-all duration-200"
              [class.text-blue-400]="activeTab === tab.id"
              [class.border-blue-500]="activeTab === tab.id"
              [class.text-gray-400]="activeTab !== tab.id"
              [class.border-transparent]="activeTab !== tab.id"
              [class.hover:text-white]="activeTab !== tab.id">
        {{ tab.label }}
      </button>
    </div>
    
    <!-- Modal Body -->
    <div class="modal-body">
      <!-- Details Tab -->
      <div *ngIf="activeTab === 'details'" class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="flex flex-col gap-1">
          <label class="text-xs text-gray-400 font-semibold uppercase tracking-wide">Project ID</label>
          <div class="text-sm font-medium text-white">{{ requestData?.projectId }}</div>
        </div>
        
        <div class="flex flex-col gap-1">
          <label class="text-xs text-gray-400 font-semibold uppercase tracking-wide">Work Order</label>
          <div class="text-sm font-medium text-white">{{ requestData?.workOrder }}</div>
        </div>
        
        <div class="flex flex-col gap-1">
          <label class="text-xs text-gray-400 font-semibold uppercase tracking-wide">Substation</label>
          <div class="text-sm font-medium text-white">{{ requestData?.substation }}</div>
        </div>
        
        <div class="flex flex-col gap-1">
          <label class="text-xs text-gray-400 font-semibold uppercase tracking-wide">Region</label>
          <div class="text-sm font-medium text-white">{{ requestData?.region }}</div>
        </div>
        
        <div class="flex flex-col gap-1">
          <label class="text-xs text-gray-400 font-semibold uppercase tracking-wide">County</label>
          <div class="text-sm font-medium text-white">{{ requestData?.county }}</div>
        </div>
        
        <div class="flex flex-col gap-1">
          <label class="text-xs text-gray-400 font-semibold uppercase tracking-wide">Total Mats</label>
          <div class="text-sm font-medium text-white">{{ requestData?.totalMats }} mats</div>
        </div>
        
        <div class="flex flex-col gap-1 md:col-span-2">
          <label class="text-xs text-gray-400 font-semibold uppercase tracking-wide">Project Manager</label>
          <div class="text-sm font-medium text-white">
            {{ requestData?.pm?.name }} {{ requestData?.pm?.phone }} | {{ requestData?.pm?.email }}
          </div>
        </div>
        
        <div class="flex flex-col gap-1 md:col-span-2">
          <label class="text-xs text-gray-400 font-semibold uppercase tracking-wide">Planner</label>
          <div class="text-sm font-medium text-white">
            {{ requestData?.planner?.name }} {{ requestData?.planner?.phone }} | {{ requestData?.planner?.email }}
          </div>
        </div>
        
        <div class="flex flex-col gap-1">
          <label class="text-xs text-gray-400 font-semibold uppercase tracking-wide">Matting Start Date</label>
          <div class="text-sm font-medium text-white">{{ requestData?.startDate }}</div>
        </div>
        
        <div class="flex flex-col gap-1">
          <label class="text-xs text-gray-400 font-semibold uppercase tracking-wide">Matting End Date</label>
          <div class="text-sm font-medium text-white">{{ requestData?.endDate }}</div>
        </div>
        
        <div class="flex flex-col gap-1 md:col-span-2">
          <label class="text-xs text-gray-400 font-semibold uppercase tracking-wide">Scope of Work</label>
          <div class="text-sm font-medium text-white">{{ requestData?.scopeOfWork }}</div>
        </div>
      </div>
      
      <!-- Other tabs content placeholders -->
      <div *ngIf="activeTab === 'allocation'">
        <p class="text-gray-400">Mat allocation details will be displayed here.</p>
      </div>
      
      <div *ngIf="activeTab === 'timeline'">
        <p class="text-gray-400">Activity timeline will be displayed here.</p>
      </div>
      
      <div *ngIf="activeTab === 'documents'">
        <p class="text-gray-400">Files and documents will be listed here.</p>
      </div>
    </div>
    
    <!-- Modal Footer -->
    <div class="modal-footer">
      <button class="secondary-button" (click)="close()">Close</button>
      <button class="primary-button" (click)="edit()">Edit Request</button>
    </div>
  </div>
</div>